export * from "./MultimediaContentDTO";
export * from "./MultimediaContentFullDTO";
